import { Button, Container, Grid, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import SettingsIllustration from './SettingsIllustration.png';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';

const MainContainer = styled('div')({
  display: 'block',
});

const GrantPermissions = styled(Typography)({
  fontSize: '16px',
  paddingBottom: '16px',
});

const Illustration = styled('img')(({ theme }) => ({
  maxHeight: '174px',
  maxWidth: '337px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Header = styled(Grid)(({ theme }) => ({
  float: 'left',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
  },
}));

const RequestButton = styled(Grid)(({ theme }) => ({
  clear: 'left',
  [theme.breakpoints.down('md')]: {
    clear: 'initial',
    marginBottom: '2em',
  },
}));

const PaperContainer = styled(Grid)(({ theme }) => ({
  float: 'right',
  marginRight: '1em',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 0 2.5em 0',
  },
}));

const StyledPaper = styled(Paper)({
  display: 'inline-block',
  padding: '20px',
  borderRadius: '8px',
});

export function CheckPermissions() {
  const { dispatch } = useAppStateContext();

  const handleClick = async () => {
    try {
      // get audio and video permissions then stop the tracks
      await navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(async (mediaStream) => {
        mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
      });
      // The devicechange event is not fired after permissions are granted, so we fire it
      // ourselves to update the useDevices hook. The 100 ms delay is needed so that device labels are available
      // when the useDevices hook updates.
      setTimeout(() => navigator.mediaDevices.dispatchEvent(new Event('devicechange')), 500);
      dispatch({ type: 'next-pane' });
    } catch (error) {
      if (error instanceof Error) dispatch({ type: 'set-device-error', error });
    }
  };

  return (
    <Container>
      <MainContainer>
        <Header item lg={5}>
          <Typography variant="h1" gutterBottom>
            Check permissions
          </Typography>
          <Typography variant="body1" gutterBottom>
            If you haven't already, you'll see a pop-up to grant Twilio permissions to access your camera and
            microphone.
          </Typography>
        </Header>

        <PaperContainer item lg={5}>
          <StyledPaper>
            <GrantPermissions variant="body1">
              <strong>Grant permissions</strong>
            </GrantPermissions>
            <Illustration src={SettingsIllustration} alt="Settings Illustration" />
          </StyledPaper>
        </PaperContainer>

        <RequestButton item lg={5}>
          <Typography variant="body1" gutterBottom>
            <strong>Allow all permissions and refresh this page.</strong>
          </Typography>

          <Button variant="contained" color="primary" onClick={handleClick}>
            Request permissions
          </Button>
        </RequestButton>
      </MainContainer>
    </Container>
  );
}
